"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportInstanceStatus = void 0;
var ReportInstanceStatus;
(function (ReportInstanceStatus) {
    ReportInstanceStatus[ReportInstanceStatus["Initiated"] = 0] = "Initiated";
    ReportInstanceStatus[ReportInstanceStatus["Processed"] = 1] = "Processed";
    ReportInstanceStatus[ReportInstanceStatus["Error"] = 2] = "Error";
})(ReportInstanceStatus = exports.ReportInstanceStatus || (exports.ReportInstanceStatus = {}));
//# sourceMappingURL=ReportInstanceStatus.js.map